import { FeedbackServerResponse } from '../../model/types/feedbackServerResponse';

export const sendFeedbackForm = async (params: { name: string; phone: string }): Promise<FeedbackServerResponse> => {
  const response = await fetch(
    `https://vigo.bitrix24.ru/rest/9224/3vh3duimr6uwiql0/crm.lead.add.json?FIELDS[TITLE]=Заявка Olevaro&FIELDS[NAME]=${params.name}&FIELDS[PHONE][0][VALUE]=${params.phone}`
  );

  return await response.json();
};
